<template>
  <div
    class="dofp-notify-modal"
    @keydown.esc="secondaryBtnAction"
    ref="dofpNotifyModal"
  >
    <div class="dofp-notify-modal__container">
      <p class="small-headline">{{ $t('WalletModal.label.continue') }}</p>

      <h1 class="extra-large-headline">
        {{ getModalTitle }}
      </h1>

      <p
        class="bodycopy"
        v-html="
          $t('DofpNotify.modal.body1', {
            riskSummaryLink: `<br /><strong><a
            ref='noreferrer noopner'
            target='_blank'
            href='https://banxa.com/due-diligence/'
              rel='nofollow'
              >${$t('DofpNotify.modal.body2')}</a
            ></strong>`,
          })
        "
      />

      <ButtonBase @click="primaryBtnAction">
        {{ $t('ButtonBase.label.iUnderstandAndProceed') }}
      </ButtonBase>
      <ButtonBase @click="secondaryBtnAction">
        {{ $t('ButtonBase.label.iUnderstandAndLeave') }}
      </ButtonBase>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, computed } from 'vue';
import gsap from 'gsap';
import { useI18n } from 'vue-i18n';

import { useIdentityConfirmationStore } from '@/stores/forms/identityConfirmationFormStore';

import ButtonBase from '@/components/ui/buttons/ButtonBase.vue';
import { useGlobalStore } from '@/stores/globalStore';

const $emit = defineEmits(['onPrimaryButtonClick']);
const dofpNotifyModal = ref(null);
const globalStore = useGlobalStore();
const identityConfirmationStore = useIdentityConfirmationStore();
const { t } = useI18n();

const getModalTitle = computed(() => {
  const givenName = identityConfirmationStore.form.givenName.value;
  return givenName
    ? t('DofpNotify.modal.title1', { firstName: givenName })
    : t('DofpNotify.modal.title2');
});

const primaryBtnAction = () => $emit('onPrimaryButtonClick');

const secondaryBtnAction = () => {
  const { returnUrl } = globalStore.getMerchantSettings;
  window.top.location.href = returnUrl;
};

onMounted(() => {
  const successTl = gsap.timeline();
  successTl.fromTo(
    '.dofp-notify-modal',
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: 'inOut.power3',
    },
  );
  dofpNotifyModal.value.focus();
});
</script>
<style lang="scss" scoped>
.dofp-notify-modal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  background: var(--modal-content-background);
  border-radius: $border-radius $border-radius 0 0;

  @include breakpoint($min-m) {
    border-radius: $border-radius;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 1.5rem 3rem;

    @include breakpoint($min-m) {
      padding: 3rem;
      max-width: 568px;
    }

    .bodycopy {
      font-size: 1.6rem;
      margin-bottom: 1.8rem;
    }

    .button {
      margin-bottom: 1rem;
    }

    .small-headline {
      color: var(--primary);
      margin-bottom: 1.8rem;
    }
  }

  &__address {
    padding: 1.5rem 3rem;
    color: var(--toggle-text-color-second);
    background: var(--input-background);
    border-radius: 1.6rem;
    text-align: center;
  }

  &__faq {
    text-align: center;
    margin-bottom: 2rem;
    a {
      text-decoration: none;
    }
  }
}
</style>
